<div class="py-4 px-0">
  <div class="container">
    <div class="row">
      <div class="col">
        <app-terms-of-use></app-terms-of-use>
      </div>
    </div>
    <!--/.row-->
  </div>
</div>
